import './scss/main.scss'
import React from 'react';
import {state} from "./state";
import {useSnapshot} from "valtio";
import Scene from './Scene'
import DataLoader from './components/loaders/DataLoader'
import MainControlPanel from "./components/ui/MainControlPanel";
import UIAPI from "./components/loaders/UIAPI";

export default function App() {
  
  const {isLoaded} = useSnapshot(state);
  
  DataLoader();
  
  if (!isLoaded) {
    return (
      <div/>
    );
  }
  
  return (
    <>
      <Scene/>
      <MainControlPanel/>
      <UIAPI/>
    </>
  );
}

